module.exports = __webpack_public_path__ + "img/aliyun.c76d8c7c.png";